import React from 'react';
import {
  AccordionActions as MuiAccordionActions,
  AccordionActionsProps as MuiAccordionActionsProps,
} from '@mui/material';

/**
 * Props that we do not want to include with AccordionActions.
 *
 * Using `keyof Pick` provides type safety that ensures we are
 * only blocking props that are part of the interface.
 **/
type AccordionActionsBlockedProps = keyof Pick<
  MuiAccordionActionsProps,
  'disableSpacing'
>;

export type AccordionActionsProps = Omit<
  MuiAccordionActionsProps,
  AccordionActionsBlockedProps
>;

/**
 * AccordionActions contains action buttons at the bottom of an Accordion item.
 *
 * Demos:
 *
 * - [Accordion — Actions](https://unify.workiva.org/components/accordion?tab=code)
 *
 * API:
 *
 * - [AccordionActions API](https://unify.workiva.org/components/accordion?tab=props#accordionactions)
 */
export const AccordionActions = React.forwardRef<
  HTMLElement,
  AccordionActionsProps
>(function UnifyAccordionActions(props, ref) {
  return <MuiAccordionActions {...props} ref={ref} />;
});
